<template>
	<div class="tusd-wrap wrap-bg">
		<cube-scroll-nav-bar :current="currentStatus" :labels="status" :txts="txts" @change="changeNav" />
		<div class="separator"></div>
		<div class="search">
			<div class="search_item">
				<cube-select @change="getOrders(1)" v-model="searchForm.payType" placeholder="请选择支付方式"
					:options="payTypeOptions">
				</cube-select>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.payName" placeholder="收款人" @change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input type="number" v-model="searchForm.minCNY" placeholder="最小金额（CNY）"
					@change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input type="number" v-model="searchForm.maxCNY" placeholder="最大金额（CNY）"
					@change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.startTime" readonly placeholder="订单开始时间"
					@focus="startDatePicker()"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.endTime" readonly placeholder="订单结束时间"
					@focus="endDatePicker()"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.orderNo" placeholder="系统/商户订单号" @change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.personalRemark" placeholder="备注" @change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-multi-select v-model="searchForm.bankGroupIds" :options="bankGroupOptions" placeholder="收款方式分组"
					title="请选择" @change="getOrders(1)" />
			</div>
			<div class="search_item ">
				<button class="search-form-btn-small" @click="exportExcel">导出账单</button>
			</div>
		</div>
		<cube-slide class="order-scroll" :options="{ click: false }" :showDots="false" :initialIndex="crtIndex"
			:autoPlay="false" :loop="false" @change="changeSlide">
			<cube-slide-item>
				<cube-scroll ref="scrollF" :data="orderF" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<Mybuyorder v-for="o in orderF" :order="o" :index="0" :searchForm="searchForm"></Mybuyorder>
						<div class="order-noData" v-if="orderF.length < 1">暂无待处理订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollS" :data="orderS" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<Mybuyorder v-for="o in orderS" :order="o" :index="1" :searchForm="searchForm"></Mybuyorder>
						<div class="order-noData" v-if="orderS.length < 1">暂无已完成订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollT" :data="orderC" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<Mybuyorder v-for="o in orderC" :order="o" :index="2" :searchForm="searchForm"></Mybuyorder>
						<div class="order-noData" v-if="orderC.length < 1">暂无已关闭订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollFO" :data="orderFO" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<Mybuyorder v-for="o in orderFO" :order="o" :index="3"></Mybuyorder>
						<div class="order-noData" v-if="orderFO.length < 1">暂无订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
		</cube-slide>
	</div>
</template>

<script>
import Mybuyorder from "@/components/mybuyorder.vue"
import CubeMultiSelect from "@/components/CubeMultiSelect.vue"
export default {
	name: 'orderbuylist',
	data() {
		return {
			currentStatus: 1,
			crtIndex: 0,
			status: [1, 3, 4, 0],
			txts: ['待处理', '已完成', '已关闭', '全部'],
			orderDesc: ["F", "S", "C", "FO"],
			scrollOptions: this.$store.state.refreshOptions,
			orderF: [],
			orderS: [],
			orderC: [],
			orderFO: [],
			pageF: 1,
			pageS: 1,
			pageC: 1,
			pageFO: 1,
			payTypeOptions: [
				{
					value: -1,
					text: '全部'
				},
				{
					value: 1,
					text: '银行卡'
				},
				{
					value: 2,
					text: '支付宝'
				},
			],
			bankGroupOptions: [],
			searchForm: {
				payType: -1,
				payName: '',
				minCNY: '',
				maxCNY: '',
				startTime: '',
				endTime: '',
				orderNo: '',
				personalRemark: ''
			}
		}

	},
	components: {
		Mybuyorder,
		CubeMultiSelect
	},
	methods: {
		startDatePicker() {
			if (!this.startTimeDatePicker) {
				this.startTimeDatePicker = this.$createDatePicker({
					title: '请选择开始时间',
					min: new Date(2023, 1, 1),
					max: new Date(2030, 12, 31),
					value: new Date(),
					onSelect: this.startSelectHandle,
					onCancel: this.startCancelHandle
				})
			}
			this.startTimeDatePicker.show()
		},
		startSelectHandle(date, selectedVal, selectedText) {
			var startTime = selectedText[0] + '-' + selectedText[1] + '-' + selectedText[2];
			this.searchForm.startTime = startTime;
			this.getOrders(1);
		},
		startCancelHandle() {
			this.searchForm.startTime = ''
		},
		endDatePicker() {
			if (!this.endTimeDatePicker) {
				this.endTimeDatePicker = this.$createDatePicker({
					title: '请选择结束时间',
					min: new Date(2023, 1, 1),
					max: new Date(2030, 12, 31),
					value: new Date(),
					onSelect: this.endSelectHandle,
					onCancel: this.endCancelHandle
				})
			}
			this.endTimeDatePicker.show()
		},
		endSelectHandle(date, selectedVal, selectedText) {
			var endTime = selectedText[0] + '-' + selectedText[1] + '-' + selectedText[2];
			this.searchForm.endTime = endTime;
			this.getOrders(1);
		},
		endCancelHandle() {
			this.searchForm.endTime = ''
		},
		changeNav(sta) {
			this.status.some((v, i) => {
				if (v == sta) {
					this.crtIndex = i
					return true
				}
			})
			if (sta == 2) {
				this.txts = ['待处理', '已完成', '已关闭', '全部']
			}
		},
		changeSlide(idx) {
			let that = this;
			//设置当前的Status值
			that.currentStatus = that.status[idx];
			var type = that.getType();
			if (!that["hasSend" + type])//没有发送请求就发送
			{
				that.getOrders();
				that["hasSend" + type] = true;
			}
		},
		refreshSearch() {
			this.searchForm = {
				payType: -1,
				payName: '',
				minCNY: '',
				maxCNY: '',
				startTime: '',
				endTime: '',
				orderNo: '',
				personalRemark: ''
			}
		},
		getType() {
			let that = this
			return that.orderDesc[that.crtIndex];
		},
		setParam() {//设置请求参数
			let that = this;
			let cstatus = that.status[that.crtIndex];
			var param = {
				pageSize: 10,
				type: cstatus
			}
			return param;
		},
		exportExcel() {
			let that = this;
			let data = that.setParam();
			if (that.searchForm.payType !== -1) {
				data["payType"] = that.searchForm.payType
			}
			if (that.searchForm.minCNY) {
				data["minCNY"] = Number(that.searchForm.minCNY)
			}
			if (that.searchForm.maxCNY) {
				data["maxCNY"] = Number(that.searchForm.maxCNY)
			}
			if (that.searchForm.payName) {
				data["payName"] = that.searchForm.payName
			}
			if (that.searchForm.startTime) {
				data["startTime"] = that.searchForm.startTime
			}
			if (that.searchForm.endTime) {
				data["endTime"] = that.searchForm.endTime
			}
			if (that.searchForm.orderNo) {
				data["orderNo"] = that.searchForm.orderNo
			}
			if (that.searchForm.personalRemark) {
				data["personalRemark"] = that.searchForm.personalRemark
			}
			if (that.searchForm.bankGroupIds && that.searchForm.bankGroupIds.length > 0) {
				data["bankGroupIds"] = that.searchForm.bankGroupIds;
			}
			data["export"] = 1;
			that.$api.getMyBuyOrder(data).then((res) => {
				this.$message.popup(res.msg, 2000);
			})
		},
		getOrders(refreshPage) {
			let that = this;
			let type = that.getType();
			that['page' + type] = that['page' + type] ? that['page' + type] : 1;//存储不同页面的页码
			let data = that.setParam();
			data["pageIndex"] = that['page' + type];  //设置当前页面的页码参数
			if (refreshPage == 1) {
				data["pageIndex"] = 1;  //设置当前页面的页码参数
				this.orderF = []
				this.orderS = []
				this.orderS = []
				this.orderFO = []

			} else {
				data["pageIndex"] = that['page' + type];  //设置当前页面的页码参数
			}

			if (that.searchForm.payType !== -1) {
				data["payType"] = that.searchForm.payType
			}
			if (that.searchForm.minCNY) {
				data["minCNY"] = Number(that.searchForm.minCNY)
			}
			if (that.searchForm.maxCNY) {
				data["maxCNY"] = Number(that.searchForm.maxCNY)
			}
			if (that.searchForm.payName) {
				data["payName"] = that.searchForm.payName
			}
			if (that.searchForm.startTime) {
				data["startTime"] = that.searchForm.startTime
			}
			if (that.searchForm.endTime) {
				data["endTime"] = that.searchForm.endTime
			}
			if (that.searchForm.orderNo) {
				data["orderNo"] = that.searchForm.orderNo
			}
			if (that.searchForm.personalRemark) {
				data["personalRemark"] = that.searchForm.personalRemark
			}
			if (that.searchForm.bankGroupIds && that.searchForm.bankGroupIds.length > 0) {
				data["bankGroupIds"] = that.searchForm.bankGroupIds;
			}
			if (that.searchForm.export == 1) {
				data["export"] = that.searchForm.export
			}
			that.$api.getMyBuyOrder(data).then((res) => {
				var data = res.data
				//后台传过来页码要存储在  that['page'+type] 之中
				that['order' + type] = that['order' + type].concat(data.Items);
				if (that['page' + type] > data.TotalPages) {
					that.$refs['scroll' + type].forceUpdate();
				} else {
					that['page' + type]++;
				}
			})
		},
		refreshData() {
			this.getOrders();
		},
		loadMoreData() {
			this.getOrders();
		},
		getUserBankGroupList() {
			let that = this;
			this.$api.getUserBankGroups().then((res) => {
				that.bankGroupOptions = res.data.map(v => ({ text: v.Title, value: v.Id }));
			});
		}
	},
	created() {
		let that = this;
		that.$parent.active = that.$store.state.routerStore.menu.active;
		that.crtIndex = that.$route.params.crtIndex ? that.$route.params.crtIndex : that.crtIndex;
		that.currentStatus = that.status[that.crtIndex];
		if (that.$store.state.routerStore.orderDetails) {
			that.searchForm = that.$store.state.routerStore.orderDetails.searchForm
		}
		var type = that.getType();
		that.getOrders();
		that["hasSend" + type] = true;
		this.getUserBankGroupList();
	}
}
</script>
<style lang="less">
* {
	.tip {
		position: absolute;
		top: 5px;
		font-size: 10px !important;
		border-radius: 100%;
		/* padding: 3px; */
		background: red;
		color: #fff;
		margin-left: 5px;
		display: inline;
		width: 20px;
		height: 20px;
		line-height: 18px;
		text-align: center;
	}
}
</style>
